import type { PlaceCategory } from './types';

/** Stable Commons thumb — only for files verified as that POI. */
function commons(file: string): string {
  return `https://commons.wikimedia.org/wiki/Special:FilePath/${encodeURIComponent(file)}?width=960`;
}

/**
 * Hard rule: if there is not a photo clearly of THAT place, do not show an image.
 * No category Unsplash fallbacks, no themed food/shop stand-ins, no nearby-cliff proxies.
 * Wikimedia only when the Commons file is actually that POI (cliffs, named beaches, parks).
 *
 * Looked up by place id (and slug when the caller passes one). Missing → null
 * so list / Favorites / detail / map cards prefer avatar initials and no banner.
 */
const BY_ID: Record<string, string> = {
  'algar-seco': commons('AlgarSecoAlgarve.jpg'),
  benagil: commons('Benagil_Cave_seen_by_above.jpg'),
  marinha: commons('Praia_da_Marinha_(35518737040).jpg'),
  'slide-splash': commons('Slide_&_Splash.jpg'),
  zoomarine: commons('Zoomarine.jpg'),
  'silves-castle': commons('Castelo_de_Silves.jpg'),
  ferragudo: commons('Ferragudo.jpg'),
  albandeira: commons('Praia_da_Albandeira.jpg'),
  'senhora-da-rocha': commons('Capela_de_Nossa_Senhora_da_Rocha.jpg'),
};

/** Slug aliases for the same verified Commons files (id keys above). */
const BY_SLUG: Record<string, string> = {
  'algar-seco-boardwalk': BY_ID['algar-seco'],
  'praia-de-benagil': BY_ID.benagil,
  'praia-da-marinha': BY_ID.marinha,
  'slide-and-splash': BY_ID['slide-splash'],
  'zoomarine-algarve': BY_ID.zoomarine,
  'castelo-de-silves': BY_ID['silves-castle'],
  'ferragudo-village': BY_ID.ferragudo,
  'praia-de-albandeira': BY_ID.albandeira,
  'senhora-da-rocha': BY_ID['senhora-da-rocha'],
};

export function imageForPlace(id: string, _category?: PlaceCategory, slug?: string): string | null {
  return BY_ID[id] ?? (slug ? BY_SLUG[slug] : undefined) ?? BY_SLUG[id] ?? null;
}

export function placeImageIds(): string[] {
  return Object.keys(BY_ID);
}
